import { FC, Fragment, ReactNode } from "react";
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
} from "@design-system/Popover/Popover";
import { Separator } from "@design-system/Separator/Separator";
import { TriangleIcon } from "@icons";
import styles from "./SummaryStats.module.scss";

interface SummaryStatsLine {
    label: ReactNode;
    value: ReactNode;
}

interface SummaryStatsProps {
    /** Content of the trigger button (the popover arrow is added automatically). */
    trigger: ReactNode;
    /** Groups of label/value lines; groups are separated by a Separator. */
    sections: SummaryStatsLine[][];
}

/** Compact stats trigger that expands into a popover breakdown. */
export const SummaryStats: FC<SummaryStatsProps> = ({ trigger, sections }) => (
    <Popover>
        <PopoverTrigger>
            <div className={styles.triggerButton}>
                {trigger}
                <TriangleIcon />
            </div>
        </PopoverTrigger>
        <PopoverContent className={styles.popoverContainer}>
            {sections.map((lines, sectionIndex) => (
                <Fragment key={sectionIndex}>
                    {sectionIndex > 0 && <Separator />}
                    {lines.map((line, lineIndex) => (
                        <div className={styles.line} key={lineIndex}>
                            <span>{line.label}</span>
                            <span>{line.value}</span>
                        </div>
                    ))}
                </Fragment>
            ))}
        </PopoverContent>
    </Popover>
);
